import type { ClientSummary } from '@/lib/types';

/** Stable order + payload for summary polling change detection. */
export function sortClientSummaries(summaries: ClientSummary[]): ClientSummary[] {
  return [...summaries].sort((a, b) => a.clientId.localeCompare(b.clientId));
}

export function computeClientsSummaryChangeKey(summaries: ClientSummary[]): string {
  return JSON.stringify(
    sortClientSummaries(summaries).map((s) => ({
      clientId: s.clientId,
      assessmentCount: s.assessmentCount,
      analysisCount: s.analysisCount,
      latestAssessmentAt: s.latestAssessmentAt,
      latestAnalysisAt: s.latestAnalysisAt,
    }))
  );
}

export function clientSummariesToCountMap(
  summaries: ClientSummary[]
): Record<string, { assessments: number; analyses: number }> {
  const counts: Record<string, { assessments: number; analyses: number }> = {};
  for (const s of summaries) {
    counts[s.clientId] = {
      assessments: s.assessmentCount,
      analyses: s.analysisCount,
    };
  }
  return counts;
}
